import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Verificar si hay una sesión guardada
    const session = localStorage.getItem('bragantinis_authenticated');
    if (session === 'true') {
      setIsAuthenticated(true);
    }
    setIsChecking(false);
  }, []);

  const login = async (clave) => {
    try {
      // En producción, usar URL relativa (Nginx redirige /api/ al backend)
      // En desarrollo, usar localhost:5000
      // Si REACT_APP_API_URL está configurado pero es HTTP, usar ruta relativa en HTTPS
      let API_URL = process.env.REACT_APP_API_URL || '';
      if (API_URL && API_URL.startsWith('http://') && window.location.protocol === 'https:') {
        // Si estamos en HTTPS pero API_URL es HTTP, usar ruta relativa
        API_URL = '';
      } else if (!API_URL && process.env.NODE_ENV !== 'production') {
        API_URL = 'http://localhost:5000';
      }
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ clave }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setIsAuthenticated(true);
          localStorage.setItem('bragantinis_authenticated', 'true');
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error('Error en login:', error);
      return false;
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('bragantinis_authenticated');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isChecking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

